<h5 class="small-caps"
    i18n>{{ header() }}</h5>
<div class="border-bottom"></div>
@if (members()) {
  <div class="list-group list-group-flush">
    @for (member of members(); track member) {
      <a [routerLink]="[routePrefix(), member.member]"
         class="list-group-item list-group-item-action py-0 d-flex align-items-center border-bottom">
        <span>{{ member.name }}</span>
      </a>
    }
  </div>
}